import { render, staticRenderFns } from "./SwitchOrderItemStatus.vue?vue&type=template&id=5abb07fb&"
import script from "./SwitchOrderItemStatus.vue?vue&type=script&lang=js&"
export * from "./SwitchOrderItemStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports